import { Column, Grid } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React from "react";

import { GhostBlock } from "@faire/retailer/components/GhostLoading/GhostBlock";

export const HeaderPlaceholder: React.FC = () => {
  return (
    <>
      {/* sub category header on mobile */}
      <ResponsiveContentV2
        mobile={
          <Grid
            gap="3x"
            columns={3}
            style={{
              placeItems: "center",
              paddingBottom: `${getSpacing("5x")}`,
            }}
          >
            {Array.from({ length: 6 }).map((_, index) => (
              <Column key={index}>
                <GhostBlock $height="72px" $borderRadius="100%" $width="72px" />
                <Spacer height="1x" />
                <GhostBlock $width="72px" $height="20px" />
                <Spacer height="1x" />
              </Column>
            ))}
          </Grid>
        }
      />
      {/* Header, height is the same as placeholder in Header.tsx */}
      <GhostBlock $width="100%" $height={getSpacing(104)} />
    </>
  );
};
